





















































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import SuporteCaixasCirurgicasStore from '@/components/Suporte/Store/SuporteCaixasCirurgicasStore'
import { CaixaCirurgica } from '@/types/_'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteCaixasCirurgicas extends Vue {
  loadEditCaixaCirurgica: string = ''
  loadAdicionarCaixaCirurgica: boolean = false

  get getSuporteCaixasCirurgicasStore() {
    return getModule(SuporteCaixasCirurgicasStore, this.$store)
  }

  get loadingEditCaixaCirurgica() { return this.loadEditCaixaCirurgica }
  set loadingEditCaixaCirurgica(value: string) { this.loadEditCaixaCirurgica = value }
  get loadingAdicionarCaixaCirurgica() { return this.loadAdicionarCaixaCirurgica }
  set loadingAdicionarCaixaCirurgica(value: boolean) { this.loadAdicionarCaixaCirurgica = value }

  get hospitalId() { return this.getSuporteCaixasCirurgicasStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteCaixasCirurgicasStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get caixaCirurgicaHeaders() {
    return [
      { text: 'Descrição', align: 'left', value: 'descricao', sortable: false },
      { text: 'HisId', align: 'left', value: 'hisId', sortable: false },
      { text: 'Status', align: 'center', value: 'status', sortable: false },
      { text: 'Ações', align: 'center', value: '', sortable: false },
    ]
  }

  get searchCaixaCirurgica() { return this.getSuporteCaixasCirurgicasStore.searchCaixaCirurgica }
  set searchCaixaCirurgica(value: string) { this.getSuporteCaixasCirurgicasStore.setSearchCaixaCirurgica(value) }

  async hospitalChange(id: any) {
    this.getSuporteCaixasCirurgicasStore.setHospitalId(id)
    await this.getSuporteCaixasCirurgicasStore.getCaixasCirurgicas(id)
  }

  async adicionarCaixaCirurgica() {
    this.loadingAdicionarCaixaCirurgica = true
    const request = await this.getSuporteCaixasCirurgicasStore.getGenericCaixasCirurgicas()
    if (!request.success) EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
    this.getSuporteCaixasCirurgicasStore.setModal({ name: 'caixaCirurgica', value: !!request.success })
    this.loadingAdicionarCaixaCirurgica = false
  }

  async editarCaixaCirurgica(item: any) {
    this.loadingEditCaixaCirurgica = item.id
    this.getSuporteCaixasCirurgicasStore.setCaixaCirurgica(item as CaixaCirurgica)
    this.getSuporteCaixasCirurgicasStore.setModal({ name: 'editCaixaCirurgica', value: true })
    this.loadingEditCaixaCirurgica = ''
  }

  beforeDestroy() {
    this.getSuporteCaixasCirurgicasStore.clearCaixasCirurgicas()
    this.getSuporteCaixasCirurgicasStore.clearGenericCaixasCirurgicas()
    this.getSuporteCaixasCirurgicasStore.clearHospitalId()
  }
}
